<template>
  <footer class="text-white border-t border-gray-400">
    <nav class="flex w-full text-xl">
      <nav-item class="flex-1" link="/home">
        <icon name="Home" />
      </nav-item>
      <nav-item class="flex-1" link="/activities">
        <icon name="Activity" />
      </nav-item>
      <nav-item class="flex-1" link="/targets">
        <icon name="Target" />
      </nav-item>
      <nav-item class="flex-1" link="/friends">
        <icon name="Contacts" />
      </nav-item>
    </nav>
  </footer>
</template>

<script>
const NavItem = require("@/modules/footer/components/NavItem.vue").default;
export default {
  name: "WdFooter",
  data() {
    return {};
  },
  props: {},
  components: {
    NavItem
  },
  methods: {},
  computed: {},
  created() {}
};
</script>
